<div class="flex column gap-10px w-100">
  <div>
    <label>{{ 'common.type' | translate | titlecase }}</label>
    <select class="form-control" [(ngModel)]="value.AddressTypeID">
      <option value="">{{ 'common.none' | translate | titlecase }}</option>
      <option *ngFor="let addressType of addressTypes" [value]="addressType.AddressTypeID">{{ addressType.AddressType }}
      </option>
    </select>
  </div>
  <div>
    <label>{{ 'common.personal-information.address' | translate | titlecase }}</label>
    <input class="form-control" type="text" [(ngModel)]="value.Address1" />
    <input class="form-control" style="margin-top:5px" type="text" [(ngModel)]="value.Address2" />
  </div>
  <div>
    <div class="flex row-collapse space-between gap-10px w-100">
      <div class="flex column" style="min-width: 50%;">
        <label>{{ 'common.personal-information.city' | translate | titlecase }}</label>
        <input class="form-control" type="text" [(ngModel)]="value.City" />
      </div>
      <div class="flex column">
        <label>{{ 'profiles.edit.general-information.state' | translate }}</label>
        <wl-state-selector-modern [(selectedState)]="addressState"></wl-state-selector-modern>
      </div>
      <div class="flex column">
        <label>{{ 'profiles.edit.general-information.zip' | translate }}</label>
        <input class="form-control" type="text" [(ngModel)]="value.Zip" />
      </div>
      <div class="flex column">
        <div style="white-space:nowrap">
          <label style="overflow-y:visible">{{ 'common.personal-information.zipext' | translate | titlecase }}</label>
        </div>
        <input class="form-control" type="text" [(ngModel)]="value.ZipExt" />
      </div>
    </div>
  </div>
  <div>
    <label>{{ 'common.personal-information.county' | translate | titlecase }}</label>
    <input class="form-control" type="text" [(ngModel)]="value.County" />
  </div>
  <div>
    <label>{{ 'common.personal-information.country' | translate | titlecase }}</label>
    <input class="form-control" type="text" [(ngModel)]="value.Country" />
  </div>
  <div>
    <label>{{ 'common.description' | translate | titlecase }}</label>
    <textarea [(ngModel)]="value.Descr" class="form-control"></textarea>
  </div>
</div>